export const CRAFT_ROOT_ID = 'ROOT';
export const NO_ACTION = 'NO_ACTION';
export const isRootNode = (nodeId?: string) => CRAFT_ROOT_ID === nodeId;
